import React from 'react'
import { withTranslation } from 'react-i18next'
import { PieChart, Pie, Cell } from 'recharts'

const SEGMENTS = [
  { key: 'reward_ads', color: '#0063eb', amount: 'GHS 0.00', percent: '0.00%', value: 0 },
  { key: 'sponsored_quiz', color: '#008744', amount: 'GHS 0.00', percent: '0.00%', value: 0 },
  { key: 'sponsored_prediction', color: '#fbb33a', amount: 'GHS 0.00', percent: '0.00%', value: 0 },
  { key: 'bonus_coins', color: '#9c46f1', amount: 'GHS 0.00', percent: '0.00%', value: 0 },
  { key: 'setup_service_fee', color: '#ba1a1a', amount: 'GHS 0.00', percent: '0.00%', value: 0 }
]

export default withTranslation()(function UsageBreakdownCard({ t }) {
  const totalUsed = SEGMENTS.reduce((sum, segment) => sum + segment.value, 0)
  const chartData = totalUsed > 0 ? SEGMENTS : [{ key: 'empty', color: '#E6EBF0', value: 1 }]

  return (
    <div className="w-full flex-1 bg-white border border-border-lines rounded-2xl p-4 flex flex-col gap-8">
      <p className="text-base font-semibold text-dark-blue">{t('billing.usage_breakdown.title')}</p>

      <div className="flex items-center gap-6">
        <div className="relative shrink-0 w-[170px] h-[170px]">
          <PieChart width={170} height={170}>
            <Pie data={chartData} dataKey="value" cx="50%" cy="50%" innerRadius={62} outerRadius={85} stroke="none">
              {chartData.map((segment) => <Cell key={segment.key} fill={segment.color} />)}
            </Pie>
          </PieChart>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
            <p className="text-xs text-secondary">{t('billing.usage_breakdown.total_used')}</p>
            <p className="text-sm font-semibold text-dark-blue">GHS {totalUsed.toFixed(2)}</p>
          </div>
        </div>

        <div className="flex-1 flex flex-col">
          {
            SEGMENTS.map((segment) => (
              <div key={segment.key} className="flex items-center gap-2 py-1.5">
                <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: segment.color }} />
                <p className="text-sm text-secondary whitespace-nowrap">{t(`billing.usage_breakdown.categories.${segment.key}`)}</p>
                <p className="flex-1 text-sm text-dark-blue text-right">{segment.amount}</p>
                <p className="text-sm text-secondary text-right w-[50px]">{segment.percent}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
})
